import { GameCard } from '@optools/components/game-card';
import { ScheduleGame } from '@optools/services/operator-gateway/types/schedule';
import { Link } from '@tanstack/react-router';

import { AuditPipelineList } from './audit-pipeline-list';

export interface AuditGameCardProps {
  game: ScheduleGame;
}

export function AuditGameCard({ game }: AuditGameCardProps) {
  return (
    <GameCard
      className="relative isolate overflow-hidden transition-colors has-[>div>a:first-of-type:hover]:bg-(--color-accent)"
      data-testid={`game-${game.gamePk}`}
      game={game}>
      <Link
        aria-label={`View audits for gamePk ${game.gamePk}`}
        className="absolute inset-0"
        from="/"
        search={{ tag: { name: 'gamePk', value: String(game.gamePk) } }}
        to="/audit/audits"
      />
      <AuditPipelineList content={game.content} pipelines={game.pipelines} />
    </GameCard>
  );
}
